module.exports = __webpack_public_path__ + "img/3-02.db4f2dce.png";